import { Col, Container, Row } from 'reactstrap';
import { MdOutlineLocationOn, MdOutlineEmail } from 'react-icons/md';
import {
    FaInstagram,
    FaYoutube,
    FaLinkedinIn,
    FaTwitter,
    FaFacebookF,
} from 'react-icons/fa';

import QaseLogoWhite from '../../../assets/images/logo/white-logo.png';
import QaseLogo from '../../../assets/images/logo/logo.png';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import useQueryParams from '../../../hooks/useQueryParams';

const Footer = ({
    footerType = 'qase',
    footerStyle = {},
    footerHeaderText = '',
    footerDescription = '',
    contacts = [],
    oppenHours = [],
    colorMode = 'dark',
    footerPoweredBy = false,
}) => {
    const { pathname } = useLocation();
    const { queryParams } = useQueryParams({
        sourceId: '',
    });
    return (
        <div
            className={`footer ${footerType} ${colorMode}`}
            style={footerStyle}
        >
            <Container>
                {footerType === 'qase' ? (
                    <>
                        <div className="footer-logo">
                            <img alt="Qase" src={QaseLogoWhite} />
                        </div>
                        <Row className="mb-5">
                            <Col xs="12" md="auto">
                                <div className="d-flex mb-4">
                                    <div className="flex-shrink-0">
                                        <MdOutlineLocationOn
                                            size={24}
                                            color="#fff"
                                        />
                                    </div>
                                    <div className="flex-grow-1 ms-2">
                                        <p className="text-white">
                                            701 - 33 Water Street
                                        </p>
                                        <p>Vancouver, BC V6B 1R4</p>
                                        <p>(844) 435-7658</p>
                                    </div>
                                </div>
                                <div className="d-flex mb-4">
                                    <div className="flex-shrink-0">
                                        <MdOutlineEmail
                                            size={24}
                                            color="#fff"
                                        />
                                    </div>
                                    <div className="flex-grow-1 ms-2">
                                        <p className="text-white">
                                            <a href="mailto:info@qase.ca">
                                                info@qase.ca
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div className="social-links">
                                    <a
                                        href="https://www.instagram.com/qasecanada"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaInstagram size={24} />
                                    </a>
                                    <a
                                        href="https://www.youtube.com/channel/UCQm1BCHrTTD62pyeTFvY4HQ"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaYoutube size={24} />
                                    </a>
                                    <a
                                        href="https://www.linkedin.com/company/qaseinc"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaLinkedinIn size={24} />
                                    </a>
                                    <a
                                        href="https://twitter.com/QaseCanada?lang=en"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaTwitter size={24} />
                                    </a>
                                    <a
                                        href="https://www.facebook.com/qasecanada"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaFacebookF size={24} />
                                    </a>
                                </div>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                        </Row>

                        <Row className="justify-content-between">
                            <Col xs="12" md="auto">
                                <p>
                                    Proudly made in Vancouver, British Columbia,
                                    Canada
                                </p>
                            </Col>
                            <Col xs="12" md="auto">
                                <p>
                                    <a href="/#">Privacy</a> |{' '}
                                    <a href="/#">Terms</a>
                                </p>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <>
                        <div className="footer-logo">
                            {footerPoweredBy ? (
                                <span style={{ fontSize: '14px' }}>
                                    <span className="q-fw-500 me-1 text-primary">
                                        Powered By
                                    </span>
                                    <img
                                        src={QaseLogo}
                                        alt="Qase"
                                        style={{ maxHeight: 32 }}
                                    />
                                </span>
                            ) : (
                                <h3 className="q-fs-22">
                                    {footerHeaderText || 'Get in touch'}
                                </h3>
                            )}
                        </div>
                        {!!footerDescription && <p>{footerDescription}</p>}
                        {!!contacts.length > 0 && (
                            <Row className="mb-3">
                                <Col xs="12" md="auto">
                                    {contacts.map((contact, index) => {
                                        const LinkTag =
                                            contact.type === 'address'
                                                ? 'span'
                                                : 'a';
                                        return (
                                            <div
                                                className="d-flex mb-3"
                                                key={index}
                                            >
                                                <div className="flex-shrink-0">
                                                    {contact.icon}
                                                </div>
                                                <div
                                                    className={classNames(
                                                        'flex-grow-1',
                                                        {
                                                            'ms-2': !!contact.icon,
                                                        },
                                                    )}
                                                >
                                                    <span>
                                                        <LinkTag
                                                            {...(contact.type ===
                                                            'address'
                                                                ? {}
                                                                : {
                                                                      href: contact.hrefText,
                                                                  })}
                                                            {...(contact.type ===
                                                            'externalLink'
                                                                ? {
                                                                      target: '_blank',
                                                                  }
                                                                : {})}
                                                        >
                                                            {contact.text}
                                                        </LinkTag>
                                                    </span>

                                                    {!!contact.helperText && (
                                                        <span className="ms-2">
                                                            {contact.helperText}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Col>
                            </Row>
                        )}
                        {!!oppenHours.length > 0 && (
                            <Row className="mb-5">
                                <Col xs="12" md="auto">
                                    {oppenHours.map((hours, index) => {
                                        return <p key={index}>{hours}</p>;
                                    })}
                                </Col>
                            </Row>
                        )}
                    </>
                )}
            </Container>
        </div>
    );
};

export default Footer;
